import CoachCardAvatar from '@efdigital/ll-addon-coaching/components/coach-card/avatar';
import type { MessageParticipant } from '@efdigital/ll-xceed-v2/utils/coaching/partnership-messages';
import type { TOC } from '@ember/component/template-only';

interface ParticipantAvatarSignature {
  Args: {
    participant: MessageParticipant;
    /** Initials fallback size. Coach photos always render at `sm`. */
    size: 'xs' | 'sm';
  };
  Element: HTMLSpanElement;
}

function initialsClass(size: 'xs' | 'sm'): string {
  return size === 'sm' ? 'll-avatar-sm small' : 'll-avatar-xs';
}

const ParticipantAvatar: TOC<ParticipantAvatarSignature> = <template>
  {{#if @participant.coach}}
    <CoachCardAvatar
      @coach={{@participant.coach}}
      @avatarUrl={{@participant.coach.photo}}
      @size="sm"
      class="flex-shrink-0"
      ...attributes
    />
  {{else}}
    <span class="flex-shrink-0" aria-hidden="true" ...attributes>
      <span
        class="{{initialsClass @size}}
          rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center fw-bold"
      >{{@participant.initials}}</span>
    </span>
  {{/if}}
</template>;

export default ParticipantAvatar;
